export function parseDateTimeToLocal(s) {
  var b = s.split(/\D/)
  return new Date(b[0], b[1] - 1, b[2], b[3], b[4], b[5])
}

export function newDateFromLocal(date, local = +7.0) {
  var targetTime = new Date(date)
  // get the timezone offset from local time in minutes
  var tzDifference = local * 60 + targetTime.getTimezoneOffset()
  // convert the offset to milliseconds, add to targetTime, and make a new Date
  return new Date(targetTime.getTime() + tzDifference * 60 * 1000)
}
